const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

export class BloomreachRecommendations extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupState()
    this.setupSections()
  }

  setupState () {
    this.productCardCache = new Map()
  }

  setupSections () {
    const sectionEls = [...document.querySelectorAll('.br-recommendations')]

    sectionEls.forEach((sectionEl) => {
      this.waitForProductCards(sectionEl)
    })
  }

  waitForProductCards (sectionEl) {
    const interval = setInterval(async () => {
      const webComponents = [...sectionEl.querySelectorAll('br-product-card')]
      if (!webComponents.length) return

      clearInterval(interval)

      const queue = webComponents.map(this.updateProductCard.bind(this))
      await Promise.allSettled(queue)

      this.setupCarousel(sectionEl)
    }, 100)
  }

  updateProductCard (cardEl) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      try {
        const linkEl = cardEl.shadowRoot.querySelector(
          '.br-product-card__link',
        )
        if (!linkEl) return

        const url = linkEl.href

        const cachedProductCard = this.productCardCache.get(url)

        if (cachedProductCard) {
          cardEl.outerHTML = cachedProductCard
        }

        const sectionHtml = await window.BAO.sectionRenderer.fetchSingle(
          'product-card-toggle-swatches',
          url,
        )

        const sectionDocument =
          window.BAO.sectionRenderer.convertToDOM(sectionHtml)

        const articleElement = sectionDocument.querySelector('article')
        const productCardHtml = articleElement ? articleElement.outerHTML : ''

        if (productCardHtml) {
          this.productCardCache.set(url, productCardHtml)
        }

        cardEl.outerHTML = productCardHtml
        resolve()
      } catch (error) {
        console.error('Failed to load Bloomreach product card', error)
      }
    })
  }

  setupCarousel (sectionEl) {
    const carouseEl = sectionEl.querySelector('.br-products__grid')
    if (!carouseEl) return

    const slideEls = [...carouseEl.querySelectorAll('.prd-Card')]
    if (!slideEls.length) return

    carouseEl.classList.add('keen-slider')

    slideEls.forEach((slideEl) => {
      slideEl.classList.add('keen-slider__slide')
    })

    return new KeenSlider(
      carouseEl,
      {
        selector: '.prd-Card',
        defaultAnimation: {
          duration: 1000,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 'auto',
          spacing: 8,
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('bloomreach-recommendations')) {
  customElements.define(
    'bloomreach-recommendations',
    BloomreachRecommendations,
  )
}
